"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSchedulerTimeslotSchemaProperties = exports.GroupSchedulerTimeslotSchema = void 0;
const zod_1 = require("zod");
const appointment_schema_1 = require("./appointment-schema");
const base_schema_1 = require("./base-schema");
const recurring_event_schema_1 = require("./recurring-event-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const TimeslotEventDetailsSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    locationType: zod_1.z.string().optional(),
    locationMemberId: zod_1.z.string().optional(),
    zoomMeetingId: zod_1.z.string().optional(),
    location: zod_1.z.string().optional().nullable(),
});
const RecurringOverrideSchema = TimeslotEventDetailsSchema.extend({
    date: zod_1.z.string(),
});
exports.GroupSchedulerTimeslotSchema = base_schema_1.BaseSchema.extend({
    startTime: zod_1.z.date(),
    endTime: zod_1.z.date(),
    duration: zod_1.z.number(),
    groupSchedulerId: zod_1.z.string(),
    recurring: zod_1.z.boolean(),
    configured: zod_1.z.boolean(),
    calendar: zod_1.z
        .object({
        id: zod_1.z.string(),
        integration: appointment_schema_1.IntegrationInfoSchema,
    })
        .optional(),
    memberId: zod_1.z.string().optional(),
    details: TimeslotEventDetailsSchema,
    calendarEventInformation: zod_1.z
        .object({
        id: zod_1.z.string(),
    })
        .optional(),
    recurringInformation: zod_1.z
        .object({
        schema: recurring_event_schema_1.RecurringEventSchema,
        seriesOverrides: zod_1.z.array(RecurringOverrideSchema),
        overrides: zod_1.z.record(zod_1.z.string(), RecurringOverrideSchema),
    })
        .optional(),
});
exports.GroupSchedulerTimeslotSchemaProperties = {
    collectionName: "groupSchedulerTimeslots",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=group-scheduler-timeslot-schema.js.map